<template>
  <div class="h-full flex">
    <el-card class="h-full mr-10px w-300px" :body-style="{ height: '100%' }">
      <div class="flex items-center">
        <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">门户页面</span>
        <el-dropdown>
          <span class="el-dropdown-link">
            <i
              class="iconfont icon-line-moreVertical text-14px font-bold text-hex-$contentTextColor"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="flex mt-10px mb-10px">
        <el-input
          clearable
          placeholder="栏目名称"
          class="flex-1 mr-10px"
          v-model="treeKeyword"
          prefix-icon="el-icon-search"
        />
        <el-button size="small" type="primary" @click="$refs.tree.filter(treeKeyword)"
          >搜索</el-button
        >
      </div>
      <el-tree
        :data="treeData"
        class="h-[calc(100%-77px)] overflow-y-auto"
        :props="{
          label: 'name',
          children: 'child',
        }"
        highlight-current
        node-key="id"
        :filter-node-method="filterTree"
        @node-click="handleNodeClick"
        v-loading="treeLoading"
        ref="tree"
        :default-expand-all="expandTree"
        :key="treeKey"
        ><el-tooltip effect="dark" :content="node.label" placement="top" slot-scope="{ node }">
          <div class="w-full truncate">{{ node.label }}</div>
        </el-tooltip>
      </el-tree>
    </el-card>
    <el-card class="h-full flex-1" :body-style="{ height: '100%' }">
      <div>
        <el-input
          size="small"
          clearable
          placeholder="布局名称"
          class="!w-280px mr-10px"
          v-model="keyword"
        />
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" type="primary" @click="openDialog('create')">新增</el-button>
        <el-button size="small" type="danger" @click="batchDelete(selection)">删除</el-button>
      </div>
      <el-table
        height="calc(100% - 106px)"
        class="mt-20px"
        border
        stripe
        :data="tableData"
        @selection-change="selectionChange"
        v-loading="tableLoading"
      >
        <el-table-column type="selection" width="60" align="center"></el-table-column>
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column label="布局名称" prop="name" show-overflow-tooltip> </el-table-column>
        <el-table-column label="页面" show-overflow-tooltip>
          <template>
            {{ pageName }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="布局方式" prop="layoutTypeName" width="95"></el-table-column> -->
        <el-table-column label="是否启用" width="80">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isActive"
              @change="enableConfig(scope.row)"
              :disabled="scope.row.isActive"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建人" prop="creatorName" show-overflow-tooltip> </el-table-column>
        <el-table-column label="创建时间" prop="creationTime" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="最近编辑人" prop="lastModifierName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="最近编辑时间" prop="lastModificationTime" show-overflow-tooltip>
        </el-table-column>
        <el-table-column width="195" label="操作">
          <template slot-scope="scope">
            <el-button @click="openDialog('read', scope.row)" size="mini">查看</el-button>
            <el-button size="mini" @click="openDialog('update', scope.row)">编辑</el-button>
            <el-button size="mini" @click="batchDelete([scope.row])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt-20px"
        background
        @size-change="searchList()"
        @current-change="findList()"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        layout="sizes, total, prev, pager, next, jumper"
        :pager-count="5"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="`${queryData.type === 'create' ? '新增' : '编辑'}布局`"
      class="mini-dialog"
      :visible.sync="dialogVisible"
      v-dialogDrag
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >
      <div>
        <el-form label-width="150px" label-position="right" :model="form" ref="form">
          <el-form-item
            label="布局名称"
            prop="name"
            :rules="[{ required: true, message: '请输入布局名称' }]"
          >
            <el-input v-model="form.name" placeholder="请输入布局名称" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="布局方式"
            prop="type"
            :rules="[{ required: true, message: '请选择布局方式' }]"
            v-if="queryData.type === 'create'"
          >
            <el-radio-group v-model="form.type">
              <el-radio :label="item.value" v-for="item in layoutTypeData" :key="item.value">{{
                item.label
              }}</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="flex justify-center items-center">
        <el-button type="primary" :loading="saveLoading" @click="next">下一步</el-button>
        <el-button @click="closeDialog(null)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ColumApi, ColumnPageApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import { layoutTypeData } from '../../js/config'

const columnApi = new ColumApi()
const columnPageApi = new ColumnPageApi()
export default {
  name: 'layoutManagement',
  data() {
    return {
      keyword: '',
      tableData: [],
      selection: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableLoading: false,
      treeLoading: false,
      treeKeyword: '',
      treeData: [],
      expandTree: false,
      treeKey: _.random(1000),
      columnId: '',
      queryData: {},
      dialogVisible: false,
      form: {
        name: '',
        type: 0,
      },
      layoutTypeData,
      saveLoading: false,
      pageName: '',
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
    routeName() {
      return this.$route.name
    },
    layoutType() {
      // 0：PC 1：APP
      return this.routeName === 'layoutManagement' ? 0 : 1
    },
  },
  methods: {
    operateTree(bol) {
      this.expandTree = bol
      this.treeKey = _.random(1000)
    },
    filterTree(value, data) {
      return data.name.includes(value)
    },
    async getTreeData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        this.treeData = res
        if (res && res.length) {
          this.handleNodeClick(res[0])
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(res[0].id)
          })
        }
      }
    },
    handleNodeClick(data) {
      this.columnId = data.id
      this.pageName = data.name
      this.searchList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.tableLoading = true
      const [err, res] = await columnPageApi.getColumnPage(this.page.pageNo, this.page.pageSize, {
        columnId: this.columnId,
        name: this.keyword,
        type: this.layoutType,
      })
      this.tableLoading = false
      if (!err) {
        this.page.pageTotal = res.totalCount
        this.tableData = _.map(res.items, (item) => {
          return {
            ...item,
            creationTime: dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss'),
            lastModificationTime: item.lastModificationTime
              ? dayjs(item.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
              : '',
            layoutTypeName: _.find(this.layoutTypeData, { value: item.layoutType })?.label || '',
          }
        })
      }
    },
    openDialog(type, row) {
      this.queryData = {
        type,
        columnId: this.columnId,
        layoutType: this.layoutType,
        layoutMode: this.form.type,
      }
      if (row) {
        this.queryData.id = row.id
        this.queryData.name = row.name
        this.queryData.layoutMode = row.layoutType
        this.form.name = row.name
      }
      if (type === 'read') {
        this.toDetail()
        return
      }
      this.dialogVisible = true
    },
    closeDialog(done) {
      this.form.name = ''
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    next() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.queryData.type === 'update' && this.form.name === this.queryData.name) {
            this.toDetail()
            return
          }
          const [err, res] = await columnPageApi.columnPageNameContains({
            name: this.form.name,
            columnId: this.columnId,
            type: this.layoutType,
          })
          if (!err) {
            if (!res) {
              this.queryData.name = this.form.name
              this.toDetail()
            } else {
              this.$message.warning('当前页面已存在该布局名称!')
            }
          }
        }
      })
    },
    toDetail() {
      this.dialogVisible = false
      this.$router.push({
        path: `${this.routerBase}/layout/layout-config`,
        query: this.queryData,
      })
    },
    selectionChange(selection) {
      this.selection = selection
    },
    batchDelete(data) {
      if (data.length === 0) {
        this.$message.warning('请选择需要删除的数据')
        return
      }
      const isActiveData = _.findIndex(data, { isActive: true })
      if (isActiveData > -1) {
        this.$message.warning('所选数据包含已启用数据')
        return
      }
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const ids = _.map(data, (item) => {
            return item.id
          })
          const [err] = await columnPageApi.deleteColumnPage({
            body: ids,
          })
          if (!err) {
            this.$message.success('删除成功!')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    // 启用布局
    enableConfig(row) {
      row.isActive = !row.isActive
      this.$confirm('是否启用当前布局', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await columnPageApi.columnPageSetActive({
            body: {
              columnId: this.columnId,
              id: row.id,
              type: row.type,
            },
          })
          if (!err) {
            this.$message.success('启用成功')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    save() {},
  },
  created() {
    this.getTreeData()
  },
}
</script>

<style lang="scss" scoped></style>
